module.exports = __webpack_public_path__ + "static/media/hualian_pic8.cf1390ea.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/hualian_pic8.jpg
 ** module id = 451
 ** module chunks = 0
 **/